export const isPwa = () => window.matchMedia('(display-mode: standalone)').matches;